import { ACTION_LOAD_FONTS } from './action-types';
import { MUTATION_LOAD_FONTS } from './mutation-types';
import { isEmpty } from 'lodash';
import { CREATOR_API } from '@/api/creator-api';

export default {
  async [ACTION_LOAD_FONTS]({ commit, state }) {
    if (isEmpty(state.fonts)) {
      const { data } = await CREATOR_API.fonts.get();
      commit(MUTATION_LOAD_FONTS, data);
    }
  }
};
